import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {Table, Upload, Button, Spin, Input, Row, Col, Divider, Breadcrumb, Menu, Icon, Dropdown, message, Modal, TreeSelect} from 'antd';
import _ from 'lodash'
import Toolbar from '../commons/Toolbar';
import { findFolder, getFolderPath, formatFileSize } from '../utils/functions'
import photoService from "../services/photo.service";
import authService from '../services/authentication.service';
import fileDownloadService from "../services/file.download.service";

const {Search} = Input;
const {confirm} = Modal

class PhotosImport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            loading: true,
            visible: false,
            loadingTree: true,
            treeData:[],
            selectedFolder: {
                _id: null,
            },
            expandedKeys: [],
            fileList: [],
            selectedFolderId: null,
            uploading: false,
            selectedRowKeys: [],
            selectedRows:[],
            okDisabled: true,
            uploading: false,
            okText: 'OK',
            message
        }
        this.upload = null
    }

    setSelectTreeProps = (parents) => {
        if (!parents || parents.length == 0) {
            return
        }
        for (const parent of parents) {
            parent.value = parent._id;
            parent.title = parent.text;
            this.setSelectTreeProps(parent.children)
        }
    }


    componentDidMount = () => {
        photoService.getImportPhotos().then((rows) => {
            console.log('importPhotos: ', rows);
            this.setState(() => {
                return {dataTable: rows, loading: false}
            })
        });

        photoService.getImportTreeData().then(data => {
            this.setSelectTreeProps(data);
            console.log("setting treeData:", data);
            this.setState({
                treeData: data,
            });
        })
            .catch(error => {
                console.log(error)
            })

    };

    handleLoadData = treeNode => {
        const folderId = treeNode.props._id;
        return new Promise( resolve => {
            if ( !_.isEmpty(treeNode.props.children) ){
                resolve();
                return;
            }
            photoService.getImportTreeData(folderId).then(data => {
                this.setSelectTreeProps(data);
                const folder = findFolder(folderId, this.state.treeData)
                folder.children = data;
                this.setState({
                    treeData: [...this.state.treeData]
                });
                resolve();
            }).catch( error => { console.error(error)});
        });
    };

    showModal = () => {
        this.setState({visible: true})
    };

    handleOk = async (e) => {
        console.log(e);
        const file = this.state.fileList[0];
        const user = authService.getAuthenticatedUser();
        const options = {
            file: file,
            data: {
                folderDestId: this.state.selectedFolderId,
                folderDestPath: getFolderPath(this.state.treeData, this.state.selectedFolderId),
                uploadedBy: user.username,
                fileSize: file.size,
                fileName: file.name
            }
        };

        this.setState({ okText: 'Uploading', uploading: true});
        photoService.savePhotoImport(options).then( (rsp) => {
            console.log("rsp:", rsp);
            this.setState({visible: false, uploading: false, okText: 'OK'});
            if (rsp != null)
            {
                photoService.getImportPhotos().then((rows) => {
                    console.log('importPhotos: ', rows);
                    this.setState(() => {
                        return {dataTable: rows, loading: false}
                    })
                });
            }
        });


    };

    handleRefresh = ()=>{
        photoService.getImportPhotos().then((rows) => {
            console.log('importPhotos: ', rows);
            this.setState(() => {
                return {dataTable: rows, loading: false, selectedRows: [], selectedRowKeys: []}
            })
        });
    }

    handleCancel = (e) => {
        console.log(e);
        this.setState({visible: false})
    };

    onChange = folderId => {
        console.log("folderId", folderId);
        const folder = findFolder(folderId, this.state.treeData)
        const user = authService.getAuthenticatedUser();
        if ( user.isAdmin() || user.isSupervisor() || user.isFolderOwner(folder)) {
            this.selectedFolderPath = getFolderPath(this.state.treeData, folderId)
            this.setState({selectedFolderId: folderId, message: this.selectedFolderPath, okDisabled: false});
        }
        else{
            this.setState({selectedFolderId: folderId, message: 'Not authorized'});
            this.setState({ okDisabled: true});
        }
    };

    cleanModal = () => {
        this.setState({
            fileList: [],
            selectedFolderId: null,
            okDisabled: true
        })
    };

    handleDeleteSelectedRows = () => {
        if (this.state.selectedRows.length > 0) {
            confirm({
                title: 'Are you sure you want to delete these photos?',
                content: 'After clicking OK the photos will be deleted permanently',
                onOk: async () => {
                    let idList = '';
                    for (let i = 0; i < this.state.selectedRows.length; i++) {
                        let id = this.state.selectedRows[i].id;
                        if (i === this.state.selectedRows.length - 1) {
                            idList = idList + id;
                        } else {
                            idList = idList + id + ',';
                        }
                    }
                    console.log('List of Ids: ', idList);
                    photoService.deleteImportPhotos(idList).then((rsp) => {
                        console.log('delete service response: ', rsp);
                        this.handleRefresh();
                    });

                }
            })
        } else {
            message.warning('Please select files to delete', [1]);
        }

    };

    handleDownloadSelectedRows = () => {
        if (this.state.selectedRows.length > 0) {
            const url = "/api/v2/importPhotos/download?id=" + this.state.selectedRows[0].id
            console.log("handleDownloadSelectedRows:", url)
            fileDownloadService.download(url).then((rsp) => {
                console.log(rsp);
            })
        } else {
            message.warning('Please select files to download', [1]);
        }
    };

    handleSearchPhotos =(e)=>{

    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        console.log('selectedRowKeys changed: ', selectedRowKeys)
        this.setState({ selectedRowKeys, selectedRows })
      }

    render() {

        const { selectedRowKeys, selectedRows } = this.state

        const columns = [
            {
                title: 'File Name',
                dataIndex: 'fileName',
                key: 'filename',
            },
            {
                title: 'File Size',
                dataIndex: 'fileSize',
                key: 'fileSize',
                render: (record) => {
                    return formatFileSize(record);
                }
            },
            {
                title: 'Uploaded By',
                dataIndex: 'uploadedBy',
                key: 'username',
                sorter: (a, b) => {
                    return a.username.localeCompare(b.username, 'en', {sensitivity: 'base', numeric: true,});
                    console.log(a.username, b.username);
                },
            },
            {
                title: 'Creation Date',
                dataIndex: 'creationDate',
                key: 'date',
                render: (creationDate)=>{
                    let date = new Date(creationDate);
                    return date.toISOString();
                }
            },
            {
                title: 'Destination Folder',
                dataIndex: 'folderDestPath',
                key: 'folderDestPath',
            },
            {
                title: 'Status',
                key: 'status',
                dataIndex: 'status',

            },
            {
                title: 'Messages',
                dataIndex: 'message',
                key: 'messages',
            },

        ];

        const pagination = {
            total: this.state.count,
            pageSize: 14,
            pageSizeOptions: ['14'],
        };

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
          };

        const toolBarItems = [
            {
                title: 'Download',
                icon: 'download',
                type: 'button',
                onClick : ()=>{
                    this.handleDownloadSelectedRows();
                },
            },
            {
                title: 'Delete',
                icon: 'delete',
                type: 'button',
                onClick : ()=>{
                    this.handleDeleteSelectedRows();
                },
            },
            {
                title: 'Refresh',
                icon: 'redo',
                type: 'button',
                onClick : ()=>{
                    console.log('Calling to refresh');
                    this.handleRefresh();
                },
            },
            {
                title: 'Upload',
                icon: 'upload',
                type: 'button',
                onClick : ()=>{
                    this.showModal();
                },
            }
        ];

        return (
            <div>
                <Row>
                    <Breadcrumb style={{margin: '16px 0'}}>
                        <Breadcrumb.Item>Photos Import</Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                </Row>
                <Row>
                    <Col span={12}>
                        <Row type="flex" justify="start">
                            <Search
                                onSearch={(value, e) => {
                                    console.log('inout search: ', value, e);
                                    if (value.trim() === ''){
                                        this.handleRefresh();
                                    }else {
                                        photoService.searchImportPhotos(value).then((rsp) => {
                                            console.log('search data:', rsp);

                                            this.setState({dataTable: rsp})
                                        });
                                    }
                                }}
                                style={{width: 330}}
                                allowClear={true}
                            />
                        </Row>
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <Toolbar items={toolBarItems}/>
                        </Row>
                    </Col>
                    <Divider style={{background: 'transparent', margin: '5px 0px 12px 0px'}}/>
                </Row>
                <div style={{boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)'}}>
                    <Spin spinning={this.state.loading} delay={500}>
                        <Table
                            dataSource={this.state.dataTable}
                            rowSelection={rowSelection}
                            columns={columns}
                            pagination={pagination}
                        />
                    </Spin>
                </div>
                <Modal
                    title="Photos import"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    afterClose={this.cleanModal}
                    okText = {this.state.okText}
                    okButtonProps={{disabled: this.state.okDisabled, loading: this.state.uploading }}
                >
                    <Upload fileList={this.state.fileList}
                            beforeUpload={ (file) => {
                                console.log("before upload file:", file)
                                this.setState({
                                    fileList: [file]
                                })
                                return false;
                            }}
                            onRemove={ (file) => {
                                console.log("remove file:", file)
                                this.setState({
                                    fileList: []
                                })
                            }}
                            multiple={false}
                        >
                        <Button>
                            <Icon type="upload"/> Click to upload zip file
                        </Button>
                    </Upload>

                    <br/>
                    {
                        this.state.selectedFolderId && <span> {this.state.message} </span>
                    }
                    <TreeSelect
                        style={{ width: '100%' }}
                        value={this.state.selectedFolderId}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder="Please select"
                        onChange={this.onChange}
                        loadData={this.handleLoadData}
                        treeData={this.state.treeData}
                    />

                </Modal>
            </div>
        )
    }
}

export default PhotosImport